export const ID_TYPES_BY_COUNTRY = {
  Nigeria: ['NIN', 'BVN', 'Voters Card', 'International Passport'],
  'United States': ['SSN', 'EIN', 'US Passport', "US Driver's License"],
  'United Kingdom': ['Passport', "Driver's License", 'Biometric Residence Permit'],
  Australia: ['Passport', "Driver's License", 'Medicare Card'],
  Canada: ['Passport', "Driver's License", 'PR Card'],
  Germany: ['Passport', 'Personalausweis (ID Card)', 'Residence Permit'],
  Singapore: ['NRIC', 'Passport', 'Employment Pass'],
  'South Africa': ['ID Document', 'Passport'],
  Kenya: ['National ID', 'Passport'],
  India: ['Aadhaar', 'PAN Card', 'Passport'],
  UAE: ['Emirates ID', 'Passport'],
  Other: ['Passport', "Driver's License"],
}

export function getCountryIdTypes(country) {
  return ID_TYPES_BY_COUNTRY[country] || ID_TYPES_BY_COUNTRY.Other
}
